import { URGENCY_MESSAGING_GET_SUCCESS } from '../actionTypes/UrgencyMessagingActionTypes';

function UrgencyMessagingReducer(state = {}, action = {}) {
    switch (action.type) {
        case URGENCY_MESSAGING_GET_SUCCESS:
            return action.urgencyStatements;
        default:
            return state;
    }
}

UrgencyMessagingReducer.reducerName = 'urgencyMessages';

export default UrgencyMessagingReducer;
